import React from 'react';
import lines from '../../../assets/img/lines/07.png';

function Service(props) {
    return (
        <section className="service-section shape-style-one section-gap grey-bg">
            <div className="container">
                {/* Section Title */}
                <div className="section-title text-center both-border mb-30">
                    <span className="title-tag">Do Hard Stuff</span>
                    <h2 className="title">J.W. runs with the philosophy that nothing is impossible.</h2>
                </div>
                {/* Services Boxes */}
                {/* <div className="row service-boxes justify-content-center">
                    {serviceblock.map((item, i) => (
                        <div key={i} className="col-lg-4 col-md-6 col-sm-8 col-10 col-tiny-12 wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="400ms">
                            <div className="service-box text-center">
                                <div className="icon">
                                    <img src={item.icon} alt="Icon" />
                                </div>
                                <h3><Link to="/servicedetail">{item.title}</Link></h3>
                                <p>{item.text}</p>
                                <Link to="/servicedetail" className="service-link">
                                    <i className="fal fa-long-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div> */}


                <div className="testimonial-item text-center">
                    <div className="author-thumb">
                        {/* <img src={item.img} alt="" /> */}
                    </div>
                    <div className="content">
                        <p>
                            <span className="quote-top">
                                {/* <i className="fal fa-quote-left" /> */}
                            </span>
                            {/* {item.comment} */}
                            He loves adventure and traveling. He enjoys seeing the world and sees an opportunity in every obstacle.
                            He has completed multiple Iron-Men races, over a dozen Half Marathons, hiked six days through Peru from
                            Cusco to Machu Picchu. He has also trekked eight days to Everest Base Camp. He is a pilot, ordained minister,
                            author, and podcast host. He loves to motivate those around him and put a smile on everyone he meets.
                            His goal is to uplift, empower and inspire others and teach them the love of Jesus.
                            <span className="quote-bottom">
                                {/* <i className="fal fa-quote-right" /> */}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="dots-line">
                <img src={lines} alt="" />
            </div>
        </section>
    );
}

export default Service;